<script lang="ts">
  import { onMount } from "svelte";
  import Home from "./pages/Home.svelte";
  import Rules from "./pages/Rules.svelte";
  import { getContainerStyle } from "../libs/layout";

  let isRulesPage = $state(
    new URLSearchParams(window.location.search).get("rules") === "true",
  );

  function syncPageState() {
    isRulesPage =
      new URLSearchParams(window.location.search).get("rules") === "true";
  }

  onMount(() => {
    window.addEventListener("popstate", syncPageState);
    return () => window.removeEventListener("popstate", syncPageState);
  });
</script>

<div class="relative m-auto" style={getContainerStyle()}>
  {#if isRulesPage}
    <Rules />
  {:else}
    <Home />
  {/if}
</div>
